const config = {
    //for accessing posts in google drive
    googleDriveApiKey: 'AIzaSyCq_VlHFnf5SkIyt9M5EYu5iBK6TN3KNFw',
     // Add your Disqus shortname
    shortname: 'your-disqus-shortname'
}
export default config


// WEBPACK FOOTER //
// ./src/config.js